
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Avatar extends Vue {
  @Prop({ type: String, required: false, default: '64' }) public size!: string;
  @Prop({ type: String, required: false, default: 'purple' }) public background!: string;
  @Prop({ type: String, required: false, default: 'white' }) public color!: string;
  @Prop({ type: String, required: false, default: 'ME' }) public text!: string;
  @Prop(String) public imageURL!: string;
  @Prop(String) public newImage!: string | ArrayBuffer | null;

  private get URL() {
    const url = process.env.VUE_APP_API?.replace(/api/i, '');
    return this.newImage ? this.newImage : `${url}${this.imageURL}`;
  }
}
